import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useSite } from "../../lib/site";
import { menuHref, href } from "../../lib/i18n";
import { SmartLink, Socials } from "./Common";
import { StyledText } from "./StyledText";

export default function Footer() {
  const { site, lang, t, ui, subtitle } = useSite();
  const g = site.general || {};
  return (
    <footer className="relative z-[2] border-t border-site-border mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Link to={href(lang, "home")} className="font-signature text-5xl text-s-primary" data-testid="footer-site-name"><StyledText style={g.site_name_style} text={t(g.site_name) || site.profile?.name} /></Link>
          <p className="mt-3 text-s-muted max-w-sm">{subtitle}</p>
          <Socials socials={site.profile?.socials} className="mt-6" />
        </div>
        <div>
          <p className="eyebrow mb-4">{ui.menu}</p>
          <ul className="space-y-2">
            {site.menu.filter((m) => menuHref(m, lang)).map((m) => (
              <li key={m.id}><SmartLink to={menuHref(m, lang)} newTab={m.new_tab} className="text-s-muted hover:text-s-primary transition-colors">{t(m.label)}</SmartLink></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4">{ui.contact}</p>
          <ul className="space-y-3 text-s-muted text-sm">
            {g.email && <li className="flex gap-2 items-center"><Mail size={15} /><a href={`mailto:${g.email}`}>{g.email}</a></li>}
            {g.phone && <li className="flex gap-2 items-center"><Phone size={15} /><a href={`tel:${g.phone}`}>{g.phone}</a></li>}
            {t(g.address) && <li className="flex gap-2 items-center"><MapPin size={15} />{t(g.address)}</li>}
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="border-t border-site-border py-6 text-center text-xs text-s-muted">
          © {new Date().getFullYear()} {t(g.site_name)}. {ui.rights}
        </div>
      </div>
    </footer>
  );
}
